import * as React from 'react'
import { memo } from 'react'
const SvgPin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 12.534 16"
  >
    <path d="M6.271 7.667a1.317 1.317 0 0 0 .972-.406 1.337 1.337 0 0 0 .4-.976 1.317 1.317 0 0 0-.406-.971 1.337 1.337 0 0 0-.976-.4 1.317 1.317 0 0 0-.972.406 1.337 1.337 0 0 0-.4.976 1.317 1.317 0 0 0 .406.972 1.337 1.337 0 0 0 .976.399Zm0 8.333a27.672 27.672 0 0 1-4.683-5.188A8.163 8.163 0 0 1 0 6.451a6.331 6.331 0 0 1 1.8-4.6A5.987 5.987 0 0 1 6.267 0a5.986 5.986 0 0 1 4.465 1.848 6.331 6.331 0 0 1 1.8 4.6 8.163 8.163 0 0 1-1.584 4.361A27.674 27.674 0 0 1 6.267 16Z" />
  </svg>
)
const Memo = memo(SvgPin)
export default Memo
